import { api } from 'src/plugins/axios'

export default {
  getUserToken
}

function getUserToken (state) {
  const userToken = window.localStorage.getItem('user-token')
  if (api.defaults.headers.common['Authorization']) {
    api.defaults.headers.common['Authorization'] = userToken
  }
  return window.localStorage.getItem('user-token')
}
